<template>
  <c-row>
    <c-col col="12">
      <c-card>
        <loader v-show="loading" />
        <c-card-header>
          <c-card-title>
            <strong>Informasi Product</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Stock</th>
                  <th>Price Buy</th>
                  <th v-for="(v, k) in report.data.header" :key="k">{{ v }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, k) in report.data.items" :key="k">
                  <td>
                    <table-number :index="k" :paginate="report.paginate" />
                  </td>
                  <td>{{ v.code }}</td>
                  <td>{{ v.name }}</td>
                  <td class="right">{{ v.qty }}</td>
                  <td class="right">{{ v.price_buy | thousandSeparator }}</td>
                  <td class="right" v-for="(vv, kk) in report.data.header" :key="k + kk">
                    {{ v[kk] | thousandSeparator }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-primary">
            <i class="cil-print"></i> Print</button>&nbsp;
          <button class="btn btn-success" @click="exportExcel">
            <i class="cil-cloud-download"></i> Excel
          </button>
          <paginator :paginator="report.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH, HTTPExport } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber2";
import Loader from '../../components/Loader.vue';
import { showErrorMessage } from '../../lib/helpers';
import Paginator from '../../components/Paginator.vue';
export default {
  data () {
    return {
      loading: true,
      report: {
        data: {
          header: [],
          items: []
        }
      },
      total: 0,
      perPage: 10,
    };
  },
  components: {
    TableNumber,
    Loader,
    Paginator,
  },
  created () {
    this.getList(1, "");
  },
  methods: {
    getList (page, q) {
      this.loading = true
      HTTPAUTH.get(
        `/api/v1/report-master/item?page=${page}&size=${this.perPage}&q=${q}`
      ).then((res) => {
        this.report = res.data;
        this.total = this.report.paginate.total;
        this.$router.push({ query: { q: q, page: page } });
        this.loading = false
      }).catch(eres => {
        this.loading = false
        showErrorMessage(eres)
      });
    },
    async exportExcel () {
      this.loading = true
      let data = null;
      await HTTPAUTH.get(`/api/v1/report-master/item/export`).then((res) => {
        data = res.data.data
      }).catch(() => {
        this.loading = false
      });
      await HTTPExport.post(`/api/v1/master/product`, data).then(res => {
        const data = res.data.data;
        window.open(data, '_blank');
      }).catch(() => {
        this.loading = false
      })
      this.loading = false
    },
    changePage (page) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.getList(page, q);
    }
  }
}
</script>